module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mediaMain"
  }, [(_vm.mediaLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("File Search Reports")]), _vm._v(" "), _c('div', [(_vm.fileSearchComplete && _vm.mediaGridSpec.tableData.length < 1) ? _c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n            File Search Reports are being generated.\n        ")]) : _vm._e(), _vm._v(" "), _c('v-client-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fileSearchComplete || _vm.mediaGridSpec.tableData.length > 0),
      expression: "!fileSearchComplete || mediaGridSpec.tableData.length > 0"
    }],
    attrs: {
      "data": _vm.mediaGridSpec.tableData,
      "columns": _vm.mediaGridSpec.columns,
      "options": _vm.mediaGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "download",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-cloud-download",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              _vm.mediaDownloadRow(props.row.mediaId, props.row.mediaTypeId, props.row.parentId, props.row.filename)
            }
          }
        })])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f540ef6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaFileSearchReport.vue
// module id = 895
// module chunks = 1